"use client";
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import heroImg from "../assets/about/clinic/3.JPG";
import cardImg from "../assets/about/clinic/5.jpg";
import drImg from "../assets/about/shah.jpeg";
import Testimonial from "../components/Testimonial/Testimonial";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const PPC1 = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({ name: '', phone: '', time: 'As soon as possible', treatment: '', notes: '' });
  const [timeOpen, setTimeOpen] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim() || !formData.phone.trim() || !formData.treatment) {
      alert("Please fill in your name, phone number, and select a treatment.");
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await fetch('/api/Bookingppc1/route', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        navigate(`/thankyou?source=${encodeURIComponent(window.location.pathname)}`);
      } else {
        alert("There was an issue sending your booking. Please try again.");
      }
    } catch (err) {
      console.error(err);
      alert("Network error. Please check your connection.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    let { name, value } = e.target;

    if (name === 'name') {
      value = value.replace(/[^a-zA-Z\s]/g, '');
    } else if (name === 'phone') {
      value = value.replace(/\D/g, '');
    }

    setFormData({ ...formData, [name]: value });
  };

  return (
    <>
      <Helmet>
        <title>Best Dentist in HSR Layout | Kosmix Dental Clinic</title>
        <meta name="description" content="Book a dentist near you same day. Painless root canals & painless implants by Dr. Shankhadeep Saha." />
        <meta property="og:title" content="Best Dentist in HSR Layout | Kosmix Dental Clinic" />
        <meta property="og:description" content="Book a dentist near you same day. Painless root canals & painless implants." />
        <meta property="og:image" content="https://www.kosmixdentalclinic.com/ogtag.JPG" />
        <meta property="og:url" content="https://www.kosmixdentalclinic.com/lp/PPC1" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://www.kosmixdentalclinic.com/ogtag.JPG" />
        <link rel="canonical" href="https://www.kosmixdentalclinic.com/lp/PPC1" />
      </Helmet>

      {/* HERO — OFFER + URGENCY */}
      <section className="hero" style={{ backgroundImage: `url(${heroImg})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
        <div className="wrap">
          <div>
            <span className="eye" style={{ color: "#FFC98A" }}>Dentist in HSR Layout, Bengaluru</span>
            <h1>Your Trusted Dental Clinic Near Me</h1>
            <p className="sub">MDS specialists Dr. Shankhadeep Saha & Dr. Sophia Saud bring 9+ years of expertise to this dental clinic in HSR Layout — painless root canals, implants, aligners & more. Walk in or reserve your slot.</p>
            <div className="hrate"><span className="s">★★★★★</span> 4.9 · 500+ Google reviews</div>
            <div className="hchips"><span className="hchip">✓ Same-day appointments</span><span className="hchip">✓ UPI & Cards accepted</span><span className="hchip">✓ Open till 10 PM</span><span className="hchip">✓ Painless Care</span></div>
          </div>
          <div>

            <div className="hmedia" style={{ padding: 0, border: '4px solid rgba(255,255,255,0.2)', aspectRatio: '1/1', overflow: 'hidden', borderRadius: '16px' }}>
              <img src={cardImg} alt="Clinic / Dr. Saha" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
          </div>
        </div></section>

      {/* GALLERY */}
      <section style={{ paddingTop: '48px', paddingBottom: '16px' }}><div className="wrap"><span className="eye">Smile Transformations</span><h2>Real Stories of Confidence Restored Through Expert Care</h2>
        <div style={{ marginTop: '16px' }} className="ppc-gallery-slider">
          <Swiper
            modules={[Pagination]}
            spaceBetween={15}
            slidesPerView={1.2}
            pagination={{ clickable: true }}
            style={{ paddingBottom: '50px' }}
            breakpoints={{
              768: { slidesPerView: 3, spaceBetween: 20 },
            }}
          >
            {['/lp_ppc1/img1.jpeg', '/lp_ppc1/img2.jpeg', '/lp_ppc1/img3.jpeg', '/lp_ppc1/img4.jpeg', '/lp_ppc1/img5.jpeg', '/lp_ppc1/img6.jpeg'].map((img, idx) => (
              <SwiperSlide key={idx}>
                <div className="gtile" style={{ padding: 0, width: '100%', flex: 'none', aspectRatio: '3/4' }}>
                  <img src={img} alt={`Smile Transformation ${idx + 1}`} style={{ width: img.includes('img5.jpeg') ? '108%' : '100%', height: '100%', objectFit: 'cover', marginLeft: img.includes('img5.jpeg') ? '-4%' : '0' }} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div></div></section>

      {/* PROOF RIBBON */}
      <div className="ribbon"><div className="wrap">
        <h2 style={{ gridColumn: '1 / -1', textAlign: 'center', marginBottom: '8px' }}>Why Patients Trust Us</h2>
        <div className="stat"><div className="n">Since 2018</div><div className="l">Trusted clinic</div></div>
        <div className="stat"><div className="n">5,000+</div><div className="l">Happy patients</div></div>
        <div className="stat"><div className="n">Same-Day
        </div><div className="l">Crowns & RCT</div></div>
        <div className="stat"><div className="n">4.9★</div><div className="l">500+ Google reviews</div></div>
      </div></div>

      {/* SERVICES */}
      <section style={{ paddingTop: '6px' }}><div className="wrap"><span className="eye">Our services</span><h2>Complete Dental Care in HSR Layout</h2>
        <div className="sg">
          <div className="svc"><div className="i">🦷</div><b>Dental Implants</b><span>3D-guided, painless</span></div>
          <div className="svc"><div className="i">⚡</div><b>Painless RCT</b><span>One visit, no pain</span></div>
          <div className="svc"><div className="i">👑</div><b>Crowns & Bridges</b><span>Natural-looking</span></div>
          <div className="svc"><div className="i">😁</div><b>Braces & Aligners</b><span>Clear options</span></div>
          <div className="svc"><div className="i">✨</div><b>Whitening & Veneers</b><span>Smile design</span></div>
          <div className="svc"><div className="i">🪥</div><b>Kids & Family</b><span>Gentle care</span></div>
          <div className="svc"><div className="i">💉</div><b>Tooth Extraction</b><span>Incl. wisdom tooth removal</span></div>
          <div className="svc"><div className="i">💧</div><b>Teeth Cleaning & Scaling</b><span>Routine hygiene, fresh in 30 min</span></div>
          <div className="svc"><div className="i">🌱</div><b>Gum Care & Laser Treatment</b><span>LANAP — Dr. Saha's specialty</span></div>
          <div className="svc"><div className="i">🛠️</div><b>Full Mouth Rehabilitation</b><span>Complete smile restoration</span></div>
          <div className="svc"><div className="i">👄</div><b>Dentures</b><span>Comfortable, custom-fit</span></div>
          <div className="svc"><div className="i">🚨</div><b>Emergency Dental Care</b><span>Same-day pain relief</span></div>
        </div></div></section>


      {/* DENTIST */}
      <section style={{ paddingTop: '8px' }}><div className="wrap"><span className="eye">Your dentists</span><h2>Meet Our Specialists</h2>
        <div className="doc">
          <div className="docimg"><img src={drImg} alt="Dr. Shankhadeep Saha" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /></div>
          <div className="doc-content">
            <h3>Dr. Shankhadeep Saha</h3><div className="role">MDS in Periodontics & Implantology</div>
            <p style={{ marginBottom: '10px' }}>Dr. Shankhadeep Saha, a leading dentist in HSR Layout, is a distinguished specialist with over 9 years of clinical expertise. He earned his Master’s in Periodontics & Implantology (MDS) from the prestigious M. S. Ramaiah University of Applied Sciences.</p>
            <p style={{ marginBottom: '10px' }}>He has completed comprehensive training in Laser Dentistry, Full Mouth Rehabilitation, Smile Designing, and Dental Implantology, allowing him to deliver sophisticated, high-precision treatments.</p>
            <p style={{ marginBottom: '10px' }}>Fueled by a passion for transforming smiles, Dr. Saha upholds the highest standards in patient care. His dedication ensures that patients receive cutting-edge treatments tailored to restore both function and aesthetics.</p>
            <p>Known for his gentle approach, he makes even complex surgeries virtually painless. He takes time to explain every step, ensuring patients feel completely relaxed, confident, and well-cared for throughout their entire treatment journey.</p>
            <div className="tags"><span>Periodontics & Implants</span><span>Painless RCT</span><span>Laser Dentistry</span></div>
          </div>
        </div>

        <div className="doc reverse">
          <div className="docimg"><img src={'/lp_ppc1/Saul.jpeg'} alt="Dr. Sophia Saud" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /></div>
          <div className="doc-content">
            <h3>Dr. Sophia Saud</h3><div className="role">MDS Endodontist & Aesthetic Specialist</div>
            <p style={{ marginBottom: '10px' }}>Dr. Sophia Saud is a highly skilled Endodontist & Aesthetic Specialist in HSR Layout, with a Master’s degree in Conservative Dentistry and Endodontics. She specializes in restorations, root canal treatments (RCTs), regenerative endodontic procedures, laser dentistry, smile designing, and veneer placements.</p>
            <p style={{ marginBottom: '10px' }}>Committed to delivering the highest standard of care, Dr. Sophia follows strict clinical protocols and performs all treatments under high-powered magnification and proper isolation.</p>
            <p style={{ marginBottom: '10px' }}>Whether revitalizing teeth through advanced regenerative therapies or crafting flawless, natural-looking smiles, Dr. Sophia’s patient-centered approach sets her apart.</p>
            <p>Her expertise in single-visit root canals ensures immediate relief with minimal discomfort. With a warm demeanor and a keen eye for aesthetics, she consistently transforms smiles and makes every dental visit a positive, stress-free experience.</p>
            <div className="tags"><span>Endodontist</span><span>Expert in RCTs & smile design</span><span>Advanced laser procedures</span></div>
          </div>
        </div>
      </div></section>

      {/* REVIEWS + SOCIAL PROOF */}
      <section style={{ paddingTop: 0, paddingBottom: '8px' }}>
        <div className="wrap">
          <Testimonial />
        </div>
      </section>

      {/* LOCATION */}
      <section style={{ paddingTop: '8px' }}><div className="wrap"><span className="eye">Find us</span><h2>Dental clinic in HSR Layout, Bengaluru</h2>
        <div className="location-grid">
          <div className="map" style={{ padding: 0 }}>
            <iframe title='Kosmix Dental Clinic Map' src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.9989629433803!2d77.6485828!3d12.907787899999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae149953a107f5%3A0xdb63ec5c78e614!2sKosmix%20Dental%20Clinic!5e0!3m2!1sen!2sin!4v1737028890133!5m2!1sen!2sin' width="100%" height="100%" style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
          </div>
          <div className="loc">
            <div className="lrow"><span className="i">📍</span><div><b>Address</b><span>1175, 24th Main Rd, near Shri Maramma Devi Devasthana, Garden Layout,<br />Sector 2, HSR Layout, Bengaluru, Karnataka 560102</span></div></div>
            <div className="lrow"><span className="i">🕙</span><div><b>Hours</b><span>Daily · 10:00 AM – 10:00 PM</span></div></div>
            <div className="lrow"><span className="i">📞</span><div><b>Phone</b><span className="phone-group"><a href="tel:+919035289171">90352 89171</a><span className="comma">, </span><a href="tel:08042083115">080 4208 3115</a></span></div></div>
          </div>
        </div></div></section>

      {/* FAQ */}
      <section style={{ paddingTop: '8px' }}><div className="wrap"><span className="eye">Good to know</span><h2>Frequently Asked Questions</h2>
        <div className="faq">
          <details open><summary>Where can I find a trusted dentist in HSR Layout? <span className="chev">▾</span></summary><p>Kosmix Dental Clinic is located in HSR Layout Sector 2, led by MDS specialists Dr. Shankhadeep Saha and Dr. Sophia Saud.</p></details>
          <details><summary>Do you treat dental emergencies near me? <span className="chev">▾</span></summary><p>Yes, we keep same-day slots open for urgent pain, broken teeth, and emergencies, till 10 PM daily.</p></details>
          <details><summary>Do you offer laser gum treatment (LANAP)? <span className="chev">▾</span></summary><p>Yes, Dr. Saha is trained in advanced laser periodontal treatment for gum disease.</p></details>
          <details><summary>Is scaling and teeth cleaning painful? <span className="chev">▾</span></summary><p>No, routine cleaning is quick and comfortable, typically done in under 30 minutes.</p></details>
          <details><summary>Do you accept walk-ins, or do I need an appointment? <span className="chev">▾</span></summary><p>Both — walk in or reserve your slot in advance for guaranteed timing.</p></details>
          <details><summary>Do you treat children at your dental clinic in HSR? <span className="chev">▾</span></summary><p>Yes, our Kids & Family care is designed to keep young patients comfortable.</p></details>
          <details><summary>Is parking available at the clinic? <span className="chev">▾</span></summary><p>Yes.</p></details>
          <details><summary>How much does a dental implant cost? <span className="chev">▾</span></summary><p>Cost depends on the case; book a consultation for an accurate quote.</p></details>
        </div></div></section>

      {/* FORM */}
      <section id="book" style={{ paddingTop: 0 }}><div className="wrap">
        <span className="eye">Book now</span>
        <h2>Grab your slot</h2>
        <p className="lead" style={{ marginBottom: '16px' }}>Tell us what you need — we'll confirm your appointment in minutes.</p>

        <div className="form-ctas">
          <a href="tel:+919035289171" className="btn c-call-solid">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path fillRule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" /></svg>
            Call Now
          </a>
          <a href="https://wa.me/919035289171?text=Hi%2C%20I%27d%20like%20to%20book%20a%20dental%20appointment" className="btn c-wa-outline">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16"><path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" /></svg>
            WhatsApp
          </a>
        </div>

        <div className="form">
          <form id="bf" noValidate onSubmit={handleSubmit}>
            <div className="fld"><label>Name</label><input name="name" autoComplete="name" placeholder="Your name" required onChange={handleChange} value={formData.name} /></div>
            <div className="fld"><label>Phone / WhatsApp</label><input name="phone" type="tel" autoComplete="tel" placeholder="Your number" required onChange={handleChange} value={formData.phone} /></div>

            <div className="fld"><label>Preferred time</label>
              <div className="custom-select-container">
                <div
                  className="custom-select-trigger"
                  onClick={() => setTimeOpen(!timeOpen)}
                >
                  <span>{formData.time}</span>
                  <span className="arrow">▼</span>
                </div>
                {timeOpen && (
                  <>
                    <div className="custom-select-overlay" onClick={() => setTimeOpen(false)} />
                    <div className="custom-options">
                      {['As soon as possible', 'Morning (10 AM - 12 PM)', 'Afternoon (12 PM - 5 PM)', 'Evening (5 PM - 10 PM)'].map((opt) => (
                        <div
                          key={opt}
                          className={`custom-option ${formData.time === opt ? 'selected' : ''}`}
                          onClick={() => {
                            setFormData({ ...formData, time: opt });
                            setTimeOpen(false);
                          }}
                        >
                          {opt}
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="fld" style={{ gridColumn: '1 / -1' }}>
              <label>What do you need? <span>(select one)</span></label>
              <div className="chips">
                {[
                  "General Checkup / Cleaning", "Fillings & Restorations",
                  "Root Canal Treatment", "Dental Implants", "Crowns & Bridges",
                  "Braces / Clear Aligners", "Teeth Whitening", "Tooth Extraction",
                  "Full Mouth Rehabilitation", "Dentures", "Kids' Dentistry",
                  "Dental Emergency / Pain", "Not Sure — Need Advice"
                ].map((opt) => (
                  <span
                    key={opt}
                    className={`chip-btn ${formData.treatment === opt ? 'selected' : ''}`}
                    onClick={() => setFormData({ ...formData, treatment: opt })}
                  >
                    {opt}
                  </span>
                ))}
              </div>
            </div>

            <div className="fld" style={{ gridColumn: '1 / -1' }}>
              <label>Anything else? <span>(optional)</span></label>
              <textarea name="notes" placeholder="e.g. tooth pain since 2 days, redoing an old root canal, etc." onChange={handleChange} value={formData.notes || ''}></textarea>
            </div>

            <button className="btn c-call" type="submit" disabled={isSubmitting} style={{ gridColumn: '1 / -1', marginTop: '4px' }}>
              {isSubmitting ? 'Sending...' : 'Reserve My Slot'}
            </button>
            <div className="form-note" style={{ gridColumn: '1 / -1' }}>
              We'll call or WhatsApp you within <b>15 minutes</b> to confirm.
            </div>
          </form>
        </div>
      </div></section>
    </>
  );
};

export default PPC1;
